var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"swiper-titles"},[(_vm.swiper.length)?_c('f7-swiper',{ref:"markers",attrs:{"params":{
      slidesPerView: 1,
      speed: 500,
      centeredSlides: true,
      on: { slideChange: _vm.slideChange }
    }}},_vm._l((_vm.swiper),function(m){return _c('f7-swiper-slide',{key:m._id},[(_vm.markerSpeech && _vm.markerSpeech._id === m._id)?_c('PlayerProgress',{attrs:{"title":m.title,"subtitle":_vm.playlistSubtitle,"progress":_vm.playlistProgress}}):_c('h2',{staticClass:"swiper-title",on:{"click":function($event){return _vm.read(m)}}},[_vm._v(" "+_vm._s(m.title)+" ")])],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }